import { useState } from 'react'

import { F0Dialog } from '@factorialco/f0-react'
import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useCostCentersMutations } from 'modules/cost_centers/hooks/useCostCentersMutations'

interface Props {
  ids: number[]
  onClose: () => void
  onSubmit: () => void
  refetchQueries?: TypedDocumentNode[]
}

export const DeleteModal = ({ ids, onClose, onSubmit, refetchQueries }: Props) => {
  const [loading, setLoading] = useState(false)

  const { deleteAssignments } = useCostCentersMutations(refetchQueries)

  const handleSubmit = async () => {
    setLoading(true)

    const successDelete = await deleteAssignments({ ids })

    if (successDelete) {
      track(trackingEvents.accounting.deleteCostCenterAssignment)

      onSubmit()
    }

    setLoading(false)
  }

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={i18n.t('finance.cost_centers.assignments.delete_modal.title')}
      width="sm"
      primaryAction={{
        label: i18n.t('common.delete'),
        onClick: handleSubmit,
        variant: 'negative',
        loading,
        disabled: loading,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
        disabled: loading,
      }}
    >
      {i18n.t('finance.cost_centers.assignments.delete_modal.description')}
    </F0Dialog>
  )
}
